import { RqmtList } from '@/ac/entities/rqmt/RqmtList';
import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';

export const SectionDetail = () => {
  
  const { entityObj } = useEntityMgr(); 

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    { id: 'rqmtTab', label: 'Requirements', content: <RqmtList sectionId={entityObj.id}/>}
  ];

  return (
    <EntityDetail tabSpecs={tabSpecs}/>
  )
}